import lazysizes from 'lazysizes'

const lsConfig = {}

Object.assign(lazysizes.cfg, lsConfig)
